import ApplicationStyles from 'app/styles/ApplicationStyles';
import { Colors, Metrics } from 'app/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    card: {
        overflow: 'hidden',
        justifyContent: 'center',
        display: 'flex',
    },
    cardRoot: {
        marginRight: '8px',
        height: '90%',
        backgroundColor: '#fdfdfd'
        // position: 'absolute', 
        // height: '75%'
    },
    root: {
        display: 'flex',
        height: '100%'
    },
    appBarSpacer: theme.mixins.toolbar,
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    button: {
        marginLeft: 8,
    },
    content: {
        flexGrow: 1,
        paddingBottom: 8,
        height: '100vh',
        overflow: 'auto',
    },
    tabContainer: {
        'marginLeft': Metrics.baseMargin,
        'marginRight': Metrics.baseMargin,
        'marginTop': Metrics.baseMargin,
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
    },
    tab: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    fill: {
        height: 20,
        width: 20,
        borderRadius: 20,
        color: Colors.primary,
        backgroundColor: Colors.primary
    },
    empty: {
        borderRadius: 20,
        height: 20,
        width: 20,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: Colors.primary,
    },
    deleteIcon: {
        color: Colors.red,
        fontSize: 20,
    },
    editIcon: {
        color: Colors.primary,
        fontSize: 20,
    },
    gridSeparatorRight: {
        paddingRight: '1%',
    },
    gridSeparatorLeft: {
        paddingLeft: '1%',
    },
    gridSeparatorTop: {
        paddingTop: '16px',
    },
    textItems: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    secondRoot: {
        width: '25%',
        padding: '8px'
    },
    azuremediaplayerDiv: {
        height: '100%',
        paddingBottom: '7%'
    },
    azuremediaplayer: {
        background: '#000',
        width: '100%',
        height: '0',
        display: 'block',
        padding: '0',
        position: 'relative',
        overflow: 'hidden',
    },
    stepsContent: {
        marginTop: '16px',
        border: '1px dashed #e9e9e9',
        borderRadius: '6px',
        backgroundColor: '#fafafa',
        minHeight: '200px',
        textAlign: 'center',
        paddingTop: '80px',
    },
    stepAction: {
        marginTop: '24px'
    },
    stepStyle: {
        marginBottom: 40,
    },
    answersContainer: {
        alignContent: 'center',
        paddingBottom: '80px',
        marginTop: '10px',
        //centering questions
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'grid',
    },
    timer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: '5%'
    }
}));

export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
	titleBox: {
        ...ApplicationStyles.margins.baseHorizontalMargin,
        ...ApplicationStyles.margins.smallVerticalMargin
    },
    inputSelect:{
    	width: '100%',
    	paddingRight: 8,
        paddingBottom: 10,
    },
    bottomDrawer:{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e8e8e8',
        padding: '10px 16px',
        textAlign: 'right',
        left: 0,
        background: '#fff',
        borderRadius: '0 0 4px 4px',
        zIndex: 1000
    },
})

